export default "__VITE_ASSET__C9qEu4Xc__"